<div class="bg-theme-red-110 w-full h-full flex flex-col">
  <div class="flex flex-row">
    <div class="w-1/2 bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/logo-h-color-white.svg)] bg-left bg-contain bg-no-repeat h-25" [routerLink]="['home']" (click)="onClose.emit()">

    </div>
    <div class="w-1/2 text-right text-white text-5xl pt-6 pr-6" (click)="onClose.emit()">
      <i class="fa-solid fa-xmark"></i>
    </div>
  </div>
  <div class="flex flex-col grow">
    <div class="h-18/30 flex flex-col mt-0 font-theme-annie text-white leading-11 text-4xl text-center font-base items-center">
      <p><a [routerLink]="['/events']" (click)="onClose.emit()" aria-label="Evenements">Événements</a></p>
      <p><a [routerLink]="['/love-profile']" (click)="onClose.emit()" aria-label="Profil amoureux">Mon profil amoureux</a></p>
      <p><a [routerLink]="['/how-it-works']" (click)="onClose.emit()" aria-label="Le concept">Le concept</a></p>
      <p><a [routerLink]="['/speeddating-for-30-years-old']" (click)="onClose.emit()" aria-label="Speed dating 30 ans et +">Speed dating 30 ans et +</a></p>
      <p><a [routerLink]="['/speeddating-for-40-years-old']" (click)="onClose.emit()" aria-label="Speed dating 40 ans et +">Speed dating 40 ans et +</a></p>
      <p><a [routerLink]="['/speeddating-for-50-years-old']" (click)="onClose.emit()" aria-label="Speed dating 50 ans et +">Speed dating 50 ans et +</a></p>
      <p><a [routerLink]="['/about-us']" (click)="onClose.emit()" aria-label="Qui sommes nous ">Qui sommes-nous ?</a></p>
      <p><a [routerLink]="['/contact']" (click)="onClose.emit()" aria-label="Nous contacter ">Nous contacter</a></p>
    </div>
    <div class="h-12/30 bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/menu/meet.svg)] bg-bottom bg-contain bg-no-repeat m-2">

    </div>
  </div>
</div>
